import { render, staticRenderFns } from "./CataloguesCardContent.vue?vue&type=template&id=4837b9f8&scoped=true"
import script from "./CataloguesCardContent.vue?vue&type=script&lang=js"
export * from "./CataloguesCardContent.vue?vue&type=script&lang=js"
import style0 from "./CataloguesCardContent.vue?vue&type=style&index=0&id=4837b9f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837b9f8",
  null
  
)

export default component.exports